import {verifiedFetch} from '@github-ui/verified-fetch'

export const request = (url: string) => {
  return async (formData: FormData) => {
    try {
      const response = await verifiedFetch(url, {
        method: 'POST',
        body: formData,
      })
      if (response.ok) {
        return {ok: true, errorMsg: ''}
      } else {
        const responseData = await response.json()
        const errMsg = responseData.error ? responseData.error : 'Failed to update'
        return {ok: false, errorMsg: errMsg}
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to update'
      return {ok: false, errorMsg: errorMessage}
    }
  }
}

export const updateSettings = request('/notifications/subscribe')
